import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import http from 'services/http';

import ConfiguracaoCategorias from './Modalidades';
import ConfiguracaoMilharBrinde from './MilharBrinde';
import styles from './styles.module.css';
import { alerta } from "../../../components/Alert";

export default function Configuracao() {
    // ?aba=categorias abre direto na aba — é o link que se manda para a banca testar
    const abaInicial = new URLSearchParams(useLocation().search).get('aba');
    const [abaAtiva, setAbaAtiva] = useState(
        ['categorias', 'milharBrinde'].includes(abaInicial) ? abaInicial : 'dados'
    );
    const [gerenteCancelar, setGerenteCancelar] = useState(true);
    const [tempoSegundaVia, setTempoSegundaVia] = useState(0);
    const [tempoCancelarAposta, setTempoCancelarAposta] = useState(0);
    const [textoBilhete, setTextoBilhete] = useState('');
    const [apostasAtivas, setApostasAtivas] = useState('');
    const [premioVoltaSaldo, setPremioVoltaSaldo] = useState('1');
    const [mostrarRetornoPule, setMostrarRetornoPule] = useState('0');
    const [comissaoMilharMoto, setComissaoMilharMoto] = useState('0');
    const [comissaoSeninha, setComissaoSeninha] = useState('0');
    const [comissaoDoisPraQuinhentos, setComissaoDoisPraQuinhentos] = useState('0');
    const [cambistas, setCambistas] = useState('0');
    const [diasInativar, setDiasInativar] = useState('30');
    const [whatsapp, setWhatsapp] = useState('');
    const [modoDataAposta, setModoDataAposta] = useState('unico');

    const [carregaPost, setCarregaPost] = useState(false);

    // Máscara (XX) XXXXX-XXXX para celular (11) ou (XX) XXXX-XXXX para fixo (10)
    const formatarWhatsapp = (valor) => {
        const digits = (valor || '').replace(/\D/g, '').slice(0, 11);
        if (digits.length <= 2) return digits ? `(${digits}` : '';
        if (digits.length <= 6) return `(${digits.slice(0, 2)}) ${digits.slice(2)}`;
        if (digits.length <= 10) return `(${digits.slice(0, 2)}) ${digits.slice(2, 6)}-${digits.slice(6)}`;
        return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
    };

    const whatsappDigitos = whatsapp.replace(/\D/g, '');
    const whatsappInvalido = whatsappDigitos.length > 0 && whatsappDigitos.length < 10;

    useEffect(() => {
        const requestEmpresas = async () => {
            try {
                const response = await http.get('/bancas/opcoes');

                const { texto_bilhete, opcoes, apostas_ativas, whatsapp } = response.data.data;

                const {
                    gerente_cancelar_apostas,
                    tempo_cancelar_aposta,
                    tempo_segunda_via,
                    comissao_milhar_moto,
                    comissao_seninha,
                    comissao_dois_pra_quinhentos,
                    dias_inativar,
                } = opcoes;
                setGerenteCancelar(gerente_cancelar_apostas);
                setTempoCancelarAposta(tempo_cancelar_aposta);
                setTempoSegundaVia(tempo_segunda_via);
                setApostasAtivas(apostas_ativas ? 1 : 0);
                setTextoBilhete(texto_bilhete || '');
                setComissaoMilharMoto(comissao_milhar_moto);
                setComissaoSeninha(comissao_seninha);
                setComissaoDoisPraQuinhentos(comissao_dois_pra_quinhentos);
                setDiasInativar(dias_inativar);
                setPremioVoltaSaldo(opcoes.premio_volta_saldo ?? '1');
                // Nasce desligado: banca que nunca escolheu não mostra o retorno possível.
                setMostrarRetornoPule((opcoes.mostrar_retorno_pule ?? false) ? '1' : '0');
                setModoDataAposta(opcoes.modo_data_aposta || 'unico');
                setWhatsapp(formatarWhatsapp(whatsapp || ''));
            } catch (e) {
                alerta(e.response.data)
            }
        };
        requestEmpresas();
        requestUsuarios();
    }, []);

    const requestUsuarios = async () => {
        try {

            const response = await http.get('/usuarios', {
                params: {
                    nivel: 'operador'
                }
            });

            setCambistas(response.data.data.length);

        } catch (e) {
            alerta(e.response.data)
        }
    };

    const mandaAlteracoes = async () => {
        try {
            if (whatsappInvalido) {
                alerta({ message: 'O WhatsApp deve ter 10 ou 11 dígitos!' });
                return;
            }

            setCarregaPost(true);

            const formData = new FormData();

            formData.append('gerente_cancelar_apostas', (gerenteCancelar === "false") ? false : true)
            formData.append('pode_cancelar_aposta', (tempoCancelarAposta === "0") ? false : true)
            formData.append('tempo_cancelar_aposta', tempoCancelarAposta)
            formData.append('tempo_segunda_via', tempoSegundaVia)
            formData.append('apostas_ativas', apostasAtivas)
            formData.append('texto_bilhete', textoBilhete)
            formData.append('comissao_milhar_moto', comissaoMilharMoto)
            formData.append('comissao_seninha', comissaoSeninha)
            formData.append('comissao_dois_pra_quinhentos', comissaoDoisPraQuinhentos)
            formData.append('dias_inativar', diasInativar)
            formData.append('premio_volta_saldo', premioVoltaSaldo)
            formData.append('mostrar_retorno_pule', mostrarRetornoPule)
            formData.append('modo_data_aposta', modoDataAposta)
            formData.append('whatsapp', whatsappDigitos)

            const res = await http.post('/bancas/opcoes', formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });

            const request = await http.get("/perfil");
            const { usuario } = request.data.data;

            await localStorage.setItem("usuario", JSON.stringify(usuario));

            alerta(res.data)
            setCarregaPost(false);
        } catch (error) {
            setCarregaPost(false);
            alerta(error.response.data)
        }
    };
    
    return (
        <>
            <div className="titulo-principal">Configurações</div>

            <div style={{ display: 'flex', gap: 4, padding: '8px 10px 0', borderBottom: '1px solid #ddd' }}>
                <button
                    type="button"
                    className={`btn btn-sm ${abaAtiva === 'dados' ? 'btn-primary' : 'btn-light'}`}
                    onClick={() => setAbaAtiva('dados')}
                >
                    Dados
                </button>
                <button
                    type="button"
                    className={`btn btn-sm ${abaAtiva === 'categorias' ? 'btn-primary' : 'btn-light'}`}
                    onClick={() => setAbaAtiva('categorias')}
                >
                    Categorias
                </button>
                <button
                    type="button"
                    className={`btn btn-sm ${abaAtiva === 'milharBrinde' ? 'btn-primary' : 'btn-light'}`}
                    onClick={() => setAbaAtiva('milharBrinde')}
                >
                    Milhar Brinde
                </button>
            </div>

            {abaAtiva === 'categorias' && <ConfiguracaoCategorias />}
            {abaAtiva === 'milharBrinde' && <ConfiguracaoMilharBrinde />}

            {abaAtiva === 'dados' && (
            <div className={styles.conteudoPrincipal}>

                <div className={styles.formGroup}>
                    <div className={styles.label}>
                        <label>Numero de cambistas cadastrados:</label>
                    </div>
                    <div className={styles.input}>
                        <input disabled className="form-control"
                            style={{ width: 200 }} value={cambistas}
                        />
                    </div>
                </div>
                <div className={styles.formGroup}>
                    <div className={styles.label}>
                        <label>Tempo em minutos para imprimir segunda via:</label>
                    </div>
                    <div className={styles.input}>
                        <input
                            type="number"
                            inputMode="numeric"
                            className="form-control"
                            style={{ width: 200 }}
                            onChange={(e) => setTempoSegundaVia(e.target.value)}
                            value={tempoSegundaVia}
                        />
                    </div>
                </div>
                <div className={styles.formGroup}>
                    <div className={styles.label}>
                        <label>Tempo em minutos para cambista cancelar aposta:</label>
                    </div>
                    <div className={styles.input}>
                        <input
                            type="number"
                            inputMode="numeric"
                            className="form-control"
                            style={{ width: 200 }}
                            onChange={(e) => setTempoCancelarAposta(e.target.value)}
                            value={tempoCancelarAposta}
                        />
                    </div>
                </div>
                <div className={styles.formGroup}>
                    <div className={styles.label}>
                        <label>Quantidade de dias para excluir cambista inativo:</label>
                    </div>
                    <div className={styles.input}>
                        <input
                            type="number"
                            inputMode="numeric"
                            min={1}
                            className="form-control"
                            style={{ width: 200 }}
                            onChange={(e) => setDiasInativar(e.target.value)}
                            value={diasInativar}
                        />
                    </div>
                </div>
                <div className={styles.formGroup}>
                    <div className={styles.label}>
                        <label>WhatsApp de suporte:</label>
                    </div>
                    <div className={styles.input}>
                        <input
                            type="tel"
                            inputMode="numeric"
                            className="form-control"
                            style={{
                                width: 200,
                                borderColor: whatsappInvalido ? '#dc3545' : undefined
                            }}
                            placeholder="(99) 99999-9999"
                            value={whatsapp}
                            onChange={(e) => setWhatsapp(formatarWhatsapp(e.target.value))}
                            maxLength={15}
                        />
                        {whatsappInvalido && (
                            <small style={{ color: '#dc3545', display: 'block' }}>
                                Informe 10 ou 11 dígitos.
                            </small>
                        )}
                    </div>
                </div>
                <div className={styles.formGroup}>
                    <div className={styles.label}>
                        <label>Apostas ativas:</label>
                    </div>
                    <div className={styles.input}>
                        <select
                            style={{ width: 200 }}
                            className="form-control"
                            name="apostasAtivas"
                            id="apostasAtivas"
                            onChange={(e) => setApostasAtivas(e.target.value)}
                        >
                            <option selected={(apostasAtivas) ? 'selected' : ''} value={1}>Sim</option>
                            <option selected={(apostasAtivas) ? '' : 'selected'} value={0}>Não</option>
                        </select>
                    </div>
                </div>
                <div className={styles.formGroup}>
                    <div className={styles.label}>
                        <label>Valor do prêmio volta para o saldo do vendedor:</label>
                    </div>
                    <div className={styles.input}>
                        <select
                            style={{ width: 200 }}
                            className="form-control"
                            value={premioVoltaSaldo}
                            onChange={(e) => setPremioVoltaSaldo(e.target.value)}
                        >
                            <option value="1">Sim</option>
                            <option value="0">Não</option>
                        </select>
                    </div>
                </div>
                <div className={styles.formGroup}>
                    <div className={styles.label}>
                        <label>Vendedor pode ver o retorno possível da pule:</label>
                    </div>
                    <div className={styles.input}>
                        <select
                            style={{ width: 200 }}
                            className="form-control"
                            value={mostrarRetornoPule}
                            onChange={(e) => setMostrarRetornoPule(e.target.value)}
                        >
                            <option value="1">Sim</option>
                            <option value="0">Não</option>
                        </select>
                    </div>
                </div>
                <div className={styles.formGroup}>
                    <div className={styles.label}>
                        <label>Modo de data de aposta:</label>
                    </div>
                    <div className={styles.input}>
                        <select
                            style={{ width: 200 }}
                            className="form-control"
                            value={modoDataAposta}
                            onChange={(e) => setModoDataAposta(e.target.value)}
                        >
                            <option value="unico">Dia único (padrão)</option>
                            <option value="semana">Semana (até domingo)</option>
                            <option value="continua">Semanas sem intervalo (7 dias rolantes)</option>
                        </select>
                    </div>
                </div>
                <div className={styles.formGroup}>
                    <div className={styles.label}>
                        <label>Gerente pode cancelar apostas:</label>
                    </div>
                    <div className={styles.input}>
                        <select
                            style={{ width: 200 }}
                            className="form-control"
                            name="gerenteCancelar"
                            id="gerenteCancelar"
                            value={gerenteCancelar}
                            onChange={(e) => setGerenteCancelar(e.target.value)}
                        >
                            <option value={true}>Sim</option>
                            <option value={false}>Não</option>
                        </select>
                    </div>
                </div>
                <div className={styles.formGroup}>
                    <div className={styles.label}>
                        <label>Texto para imprimir ao final do bilhete:</label>
                    </div>
                    <div className={styles.input}>
                        <textarea
                            className='form-control'
                            style={{ width: 300 }}
                            rows='5'
                            maxLength={350}
                            onChange={(e) => setTextoBilhete(e.target.value)}
                            value={textoBilhete}
                        >
                            {textoBilhete}
                        </textarea>
                        <small style={{ color: '#6c757d' }}>{textoBilhete.length}/350</small>
                    </div>
                </div>

                <div className={styles.buttonStyle}>
                    <button
                        className='btn btn-success'
                        onClick={() => mandaAlteracoes()}
                        disabled={carregaPost}
                    >
                        Salvar
                    </button>
                </div>

            </div>
            )}
        </>
    );
}
